import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    required: {
        color: theme.palette.error.main,
    },
    formHelperText: {
        marginTop: theme.spacing(0.75),
    },
}));
